/**
 * Defines global message to place above all scenes
 * Level can be any 'color' variant supported by prism Message (https://prism.coxautoinc.com/elements/messages/messages--code)
 * Setting message to empty string will suppress display
 */
import { DeployEnvironment, environment } from './ENV';
import { Variant } from '@sd/prism';
import { mergeDeepRight } from 'ramda';

export type globalMessage = {
  level: Variant;
  message: string;
  title: string;
};

const defaultMsg: globalMessage = {
  level: 'info',
  message: '',
  title: ''
};

//set the right-hand arguement of 'mergeDeepRight' to '{}' to use default
const messages: Record<DeployEnvironment, globalMessage> = {
  test: mergeDeepRight(defaultMsg, {}),
  dev: mergeDeepRight(defaultMsg, {}),
  int1: mergeDeepRight(defaultMsg, {}),
  int5: mergeDeepRight(defaultMsg, {}),
  uat: mergeDeepRight(defaultMsg, {}),
  prod: mergeDeepRight(defaultMsg, {})
};

export const GLOBAL_MESSAGE_CONFIG = messages[environment];
